// src/utils/sharedPrefManager.js

const KEYS = {
  USER: 'user',
  SUB_USER: 'subUser',
  APP_VERSION: 'key_app_version',
  PP_NAME: 'key_pp_name',
  PP_NUMBER: 'key_pp_number',
  STATUS_SCAN: 'key_status_scan',
  MODE_KEY: 'selected_mode',
  QRCODE_LOG_ID: 'key_qrcode_log_id',
  BANK: 'key_bank',
  ACCOUNT_NUMBER: 'key_account_number',
  ACCOUNT_NUMBER_TO: 'key_account_number_to',
  BANK_SHORT_TO: 'key_bank_short_to'
};

export const saveUser = (user) => {
  localStorage.setItem(KEYS.USER, JSON.stringify(user));
};

export const getUser = () => {
  const userStr = localStorage.getItem(KEYS.USER);
  try {
    return userStr ? JSON.parse(userStr) : null;
  } catch (e) {
    console.error('Error parsing user from localStorage', e);
    return null;
  }
};

export const saveSubUser = (subUser) => {
  localStorage.setItem(KEYS.SUB_USER, JSON.stringify(subUser));
};

export const getSubUser = () => {
  const subUserStr = localStorage.getItem(KEYS.SUB_USER);
  try {
    return subUserStr ? JSON.parse(subUserStr) : null;
  } catch (e) {
    console.error('Error parsing subUser from localStorage', e);
    return null;
  }
};

export const saveStatusScan = (status) => {
  localStorage.setItem(KEYS.STATUS_SCAN, status);
};

export const getStatusScan = () => {
  return localStorage.getItem(KEYS.STATUS_SCAN) === 'true';
};

export const savePromptPay = (name, phone) => {
  localStorage.setItem(KEYS.PP_NAME, name);
  localStorage.setItem(KEYS.PP_NUMBER, phone);
};

export const getPromptPayNumber = () => {
  return localStorage.getItem(KEYS.PP_NUMBER);
};

export const getPromptPayName = () => {
  return localStorage.getItem(KEYS.PP_NAME);
};

export const saveCurrentMode = (mode) => {
  localStorage.setItem(KEYS.MODE_KEY, mode);
};

export const getCurrentMode = () => {
  return parseInt(localStorage.getItem(KEYS.MODE_KEY), 10) || 0;
};

export const saveQrCodeLogId = (id) => {
  localStorage.setItem(KEYS.QRCODE_LOG_ID, id);
};

export const getQrCodeLogId = () => {
  return parseInt(localStorage.getItem(KEYS.QRCODE_LOG_ID), 10) || -1;
};

export const saveScanNotification = (notification) => {
  if (notification.accountNumberTo) {
    localStorage.setItem(KEYS.ACCOUNT_NUMBER_TO, notification.accountNumberTo);
  }
  if (notification.bankShortTo) {
    localStorage.setItem(KEYS.BANK_SHORT_TO, notification.bankShortTo);
  }
};

export const getScanAccountNumber = () => {
  return localStorage.getItem(KEYS.ACCOUNT_NUMBER_TO);
};

export const getScanBank = () => {
  return localStorage.getItem(KEYS.BANK_SHORT_TO);
};

export const getAppVersion = () => {
  return localStorage.getItem(KEYS.APP_VERSION);
};

export const setAppVersion = (version) => {
  localStorage.setItem(KEYS.APP_VERSION, version);
};

export const getUsername = () => {
  const user = getUser();
  return user ? user.username : null;
};

export const setBank = (bank) => {
  localStorage.setItem(KEYS.BANK, bank);
};

export const getBank = () => {
  return localStorage.getItem(KEYS.BANK);
};

export const setAccountNumber = (accountNumber) => {
  localStorage.setItem(KEYS.ACCOUNT_NUMBER, accountNumber);
};

export const getAccountNumber = () => {
  return localStorage.getItem(KEYS.ACCOUNT_NUMBER);
};

export const getSubUserId = () => {
  const subUser = getSubUser();
  return subUser ? subUser.id : -1;
};

export const getUserId = () => {
  const user = getUser();
  return user ? user.userId : -1;
};

export const clear = () => {
  localStorage.clear();
};
